import { createContext, useContext } from 'react';

export type TournamentsTab = 'my' | 'public' | 'archived';

export interface TournamentsListLayoutContextType {
  activeTab: TournamentsTab;
  isMobile: boolean;
}

export const TournamentsListLayoutContext = createContext<TournamentsListLayoutContextType | undefined>(undefined);

export function useTournamentsListContext() {
  const ctx = useContext(TournamentsListLayoutContext);
  if (!ctx) throw new Error('useTournamentsListContext must be used within TournamentsListLayout');
  return ctx;
}
